export function isNonNullObject(param) {
    return param != null && typeof param === 'object';
}

/**
 * Format an amount with the account's selling currency.
 *
 * The currency is NEVER a literal in this widget - it arrives as
 * `bwData.account.currency`, produced by home/booking_v2.blade.php (hosted) and
 * Api\BookingController::widget() (remotely embedded), both reading
 * Account::getCurrencyAttribute(). If it is missing (an old bundle host, or a
 * payload built before this key existed) render the bare number rather than
 * asserting a currency we do not actually know.
 *
 * @param {number|string} amount
 * @param {string} [currency]
 * @returns {string}
 */
export function formatMoney(amount, currency) {
    const code = typeof currency === 'string' ? currency.trim() : '';
    // Prices may have two decimals: 12.5 -> "12.50", like the app; whole amounts stay "120".
    const value = Number(amount);
    const text = Number.isFinite(value) && !Number.isInteger(value) ? value.toFixed(2) : `${amount}`;

    return code ? `${text} ${code}` : text;
}

// Codul secret al rezervarii: 32 de caractere hex din crypto.getRandomValues. Serverul il salveaza
// langa rezervare si il accepta la verificarea "a ajuns rezervarea?" in locul IP-ului, care se
// poate schimba chiar in clipa trimiterii (Wi-Fi -> date mobile, iCloud Private Relay). Fara crypto
// (browsere foarte vechi) nu trimitem nimic si regasirea ramane pe IP, ca inainte: un cod slab ar
// deschide exact scurgerea pe care o previne conditia de IP. Acelasi cod tine si ora aleasa
// (rezervarea temporara, utils/slotHold.js), deci se creeaza la alegerea orei si se refoloseste la Finalize.
export function newClientRef() {
  try {
    const c = (typeof window !== 'undefined') && (window.crypto || window.msCrypto);
    if (!c || !c.getRandomValues) return null;
    const b = new Uint8Array(16);
    c.getRandomValues(b);
    return Array.prototype.map.call(b, (x) => ('0' + x.toString(16)).slice(-2)).join('');
  } catch (e) {
    return null;
  }
}
